import React, { useState } from "react";
import { useFormik } from "formik";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import compInfos from "./add-new-workspace-form.json";
import { useLangContext } from "../../context/langContext";
import { object, string } from "yup";
import MuiTextField from "../../components/common/text-field/MuiTextField";
import { WorkspaceCreateRequest } from "../../services/Endpoints/workspaces";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import { useWorkspaceContext } from "../../context/workspaceContext";

export default function AddNewWorkForm() {
  const [waiting, setWaiting] = useState(false);
  const { setWorkSpaceModal } = useWorkspaceContext();

  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();
  const { lang } = useLangContext();

  const infos = compInfos[lang];
  const loginSchema = object({
    name: string().min(3),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setWaiting(true);
      const workspaceCreateRequest = new WorkspaceCreateRequest(
        protectedInstance
      );
      console.log(values);
      try {
        const { name } = values;
        const resp = await workspaceCreateRequest.send({ name });

        setWaiting(false);
        setWorkSpaceModal(false);
      } catch (error: any) {
        errorResolver({ error, setNotification });
        setWaiting(false);
      }
    },
    enableReinitialize: true,
  });

  return (
    <Stack
      maxWidth="100%"
      width="100%"
      gap="20.31px"
      mx="auto"
      mt="18px"
      component="form"
      onSubmit={formik.handleSubmit}
    >
      {infos.inputs.map(({ Example, errors, label, name, placeholder }) => (
        <MuiTextField
          key={name}
          width="100%"
          label={label}
          placeholder={placeholder}
          name={name}
          type="text"
          value={formik.values[name as "name"]}
          handleChange={formik.handleChange}
          Example={Example}
          error={
            formik.touched[name as "name"] &&
            Boolean(formik.errors[name as "name"]) &&
            formik.errors[name as "name"]
          }
        />
      ))}
      <LoadingButton
        variant="confirm"
        sx={{
          mt: "10px",
        }}
        type="submit"
        loading={waiting}
      >
        {infos.buttonText}
      </LoadingButton>
    </Stack>
  );
}
